import React from "react";
import { Link } from "react-router-dom";
import {
    FaLock,
    FaEnvelope,
    FaArrowRight,
    FaArrowLeft,
    FaHome,
} from "react-icons/fa";
import "../../../assets/css/General/forgotpassword.css";

function ForgotPassword({
    userType = "buyer",
    loginPath = "/login",
    onSubmit,
    email,
    setEmail,
    loading,
    error,
}) {
    return (
        <div className="fp-page">
            <div className="fp-wrapper">

                {/* ================= LEFT PANEL ================= */}
                <div className="fp-left">

                    <span className="fp-badge">
                        <FaLock /> Forgot Password?
                    </span>

                    <h1 className="fp-heading">
                        Forgot Your{" "}
                        <span className="fp-heading-accent">
                            Password?
                        </span>
                    </h1>

                    <p className="fp-subtext">
                        No worries! Enter your email address and we'll
                        send you a verification link to reset your{" "}
                        {userType === "seller" ? "seller" : "buyer"} account password.
                    </p>

                    <form
                        className="fp-form"
                    >
                        <label
                            className="fp-label"
                            htmlFor="fp-email"
                        >
                            Email Address
                        </label>

                        <div className="fp-input-wrap">
                            <FaEnvelope className="fp-input-icon" />

                            <input
                                id="fp-email"
                                type="email"
                                className={`fp-input ${error ? "fp-input-error" : ""
                                    }`}
                                placeholder="Enter your email address"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                }}
                            />
                        </div>

                        {error && (
                            <p className="fp-error-text">
                                {error}
                            </p>
                        )}

                        <button
                            type="button"
                            className="fp-submit-btn"
                            disabled={loading}
                            onClick={onSubmit}
                        >
                            {loading ? (
                                <span className="fp-spinner">
                                    ⟳
                                </span>
                            ) : (
                                <>
                                    <span>Send OTP</span>
                                    <FaArrowRight />
                                </>
                            )}
                        </button>

                    </form>

                    <Link
                        to={loginPath}
                        className="fp-back-link"
                    >
                        <FaArrowLeft /> Back to Login
                    </Link>

                </div>

                {/* ================= RIGHT PANEL ================= */}
                <div className="fp-right">

                    <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZZzXmtHDvrpG5V28qnmGJV3g1-WDEKzVz9zqHHpXfcZl0mcH40S6mmBE&s=10"
                        alt="Estate Experts Property"
                        className="fp-right-image"
                    />

                    <div className="fp-right-overlay" />

                    <div className="fp-floating-card">

                        <div className="fp-floating-icon">
                            <FaHome />
                        </div>

                        <div>
                            <p className="fp-floating-title">
                                Your Dream Home is Just a Click Away
                            </p>

                            <p className="fp-floating-text">
                                Reset your password and get back to your account.
                            </p>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    );
}

export default ForgotPassword;